import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
  },
}));

export default function InputSelectGame({
  startDate,
  endDate,
  setSelectValue,
}) {
  const classes = useStyles();

  const [idGame, setIdGame] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  const onGameChanged = useCallback(
    (event) => {
      setIdGame(event.target.value);
      setSelectValue(event.target.value);
    },
    [setSelectValue]
  );

  const [games, setGames] = useState([]);
  useEffect(() => {
    setIdGame(0);
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      `/Reports/Report_GetGamesPerDate?startDate=${startDate}&endDate=${endDate}`;
    Axios.get(url)
      .then((response) => response.data)
      .then((data) => setGames(data));
  }, [startDate, endDate]);

  return (
    <FormControl
      className={`${classes.formControl}`}
      size="small"
      variant="outlined"
    >
      <InputLabel shrink id="Game">
        Game
      </InputLabel>
      <Select
        labelId="Game"
        value={idGame}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        onChange={onGameChanged}
      >
        <div className=" flex items-center justify-center px-[16px] py-[6px] gap-4 border-b border-gray-200">
          <span className="w-9">Sport</span>
          <span className="w-20 text-center">#</span>
          <span className="flex-1">Game</span>
          <span className="text-right w-9">Status</span>
        </div>
        {games &&
          games.map((game) => (
            <MenuItem value={game?.IdGame} key={game?.IdGame}>
              <div className="flex items-center justify-center flex-1 gap-4 text-xxs leading-[10px]">
                <span className="w-9">{game?.IdSport}</span>
                <div className="flex flex-col items-center justify-center w-20">
                  {game?.VisitorNumber ? (
                    <span>{game?.VisitorNumber}</span>
                  ) : null}
                  {game?.HomeNumber ? <span>{game?.HomeNumber}</span> : null}
                </div>
                <div className="flex flex-col justify-center flex-1">
                  {game?.VisitorTeam ? <span>{game?.VisitorTeam}</span> : null}
                  {game?.HomeTeam && !game?.IdSport.includes("TNT") ? (
                    <span>{game?.HomeTeam}</span>
                  ) : null}
                </div>
                <span>{game?.GameStat}</span>
              </div>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
